import { render, staticRenderFns } from "./ListIncidenciaPage.vue?vue&type=template&id=70f967f7&scoped=true"
import script from "./ListIncidenciaPage.vue?vue&type=script&lang=js"
export * from "./ListIncidenciaPage.vue?vue&type=script&lang=js"
import style0 from "./ListIncidenciaPage.vue?vue&type=style&index=0&id=70f967f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f967f7",
  null
  
)

export default component.exports